import React from 'react';
import PropTypes from 'prop-types';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

const Datetimepicker = ({
  id,
  name,
  label,
  value,
  defaultValue,
  onChange,
  sx,
  error,
  disablePast,
  maxDate,
  disabled,
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={['DateTimePicker']}>
      <DateTimePicker
        id={id}
        name={name}
        label={label}
        value={value}
        defaultValue={defaultValue ? dayjs(defaultValue) : defaultValue}
        onChange={onChange}
        sx={sx}
        slotProps={{
          textField: {
            error: error !== '',
            helperText: error,
          },
        }}
        format="DD/MM/YYYY hh:mm:ss A"
        disablePast={disablePast}
        maxDate={maxDate}
        disabled={disabled}
      />
    </DemoContainer>
  </LocalizationProvider>
);

Datetimepicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  disablePast: PropTypes.bool,
  maxDate: PropTypes.object,
  disabled: PropTypes.bool,
};
Datetimepicker.defaultProps = {
  sx: {},
  value: null,
  defaultValue: null,
  error: '',
  disablePast: false,
  disabled: false,
  maxDate: {},
};

export default Datetimepicker;
